module.exports = __webpack_public_path__ + "static/media/loading.ca9442b7.gif";